import TextFading from '~/components/TextFading'
import Card from '../DocumentListCard'

import {
  Buttons,
  Container,
  Description,
  FramedImageWrapper,
  Header,
  ImageWrapper,
  StyledButton,
  Title
} from './GenericObjectCard.styles'

import { GenericObjectCardProps } from './GenericObjectCard.types'

const GenericObjectCard = ({
  des,
  complement,
  image,
  frameImage = false,
  imageProps,
  imageHeight,
  imageFormat,
  children,
  defaultButton,
  onDefaultButtonClick,
  fullHeight = false,
  applyFadingOverTitle = false,
  complementLines = 0,
  ...divProps
}: GenericObjectCardProps) => {
  const renderImage = () => {
    if (typeof image === 'string') {
      return <img {...imageProps} src={image} />
    }

    return image
  }

  return (
    <Card spacingClass='regular' {...divProps} {...{ fullHeight }}>
      <Container>
        <Header isImageFramed={frameImage}>
          {frameImage ? (
            <FramedImageWrapper
              imageHeight={imageHeight}
              imageFormat={imageFormat}
            >
              {renderImage()}
            </FramedImageWrapper>
          ) : (
            <ImageWrapper imageHeight={imageHeight}>
              {renderImage()}
            </ImageWrapper>
          )}
          {!frameImage &&
            (typeof defaultButton === 'string' ? (
              <StyledButton
                heightClass='small'
                variant='secondary'
                onClick={onDefaultButtonClick}
              >
                {defaultButton}
              </StyledButton>
            ) : (
              defaultButton
            ))}
        </Header>
        {applyFadingOverTitle ? (
          <TextFading>
            <Title>{des}</Title>
          </TextFading>
        ) : (
          <Title>{des}</Title>
        )}
        <Description $lines={complementLines}>{complement}</Description>
        <Buttons role='group'>{children}</Buttons>
      </Container>
    </Card>
  )
}

export default GenericObjectCard
